/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Text,
  HStack,
  Divider,
  ModalFooter,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spacer,
  useToast,
  useDisclosure,
  Input,
  Button,
} from '@chakra-ui/react';
import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../Config/firebase';
import {
  addDocumentFirebase,
  deleteDocumentFirebase,
  getCollectionFirebase,
} from '../../Api/firebaseApi';
import useUserStore from '../../Hooks/Zustand/Store';

import 'react-date-range/dist/styles';
import 'react-date-range/dist/theme/default.css';

import { useNavigate } from 'react-router-dom';
import BackButtons from '../../Components/Buttons/BackButtons';
import DynamicButton from '../../Components/Buttons/DynamicButton';
import DynamicTable from '../../Components/Table/DynamicTable';
import { PiShareBold } from 'react-icons/pi';
import ComponentExportExcel from '../../Utils/ExportExcel';


const ProductPageV2 = () => {
  const navigate = useNavigate();
  const globalState = useUserStore();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [name, setName] = useState('')
  const [dataProduct, setDataProduct] = useState([])
  const toast = useToast()


  const itemsPerPage = 8;


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // console.log(globalState.currentProject, 'project')
  const createNewProduct = async () => {
    const unix = name.toLowerCase() + ' ' + Date.now();
    const slug = unix.split(' ').join('-')

    const data = {
      companyId: globalState?.currentCompany,
      projectId: globalState?.currentProject,
      name: name,
      // slug: slug
    };
    try {
      const id = await addDocumentFirebase('discounts', data, globalState.currentCompany);
      if (id) navigate(id);
    } catch (error) {
      console.log(error.message, ' error add discount')
    }
  };

  const getData = async () => {
    const startIndex = (currentPage - 1) * itemsPerPage;

    const conditions = [
      {
        field: 'companyId',
        operator: '==',
        value: globalState.currentCompany,
      },
      {
        field: 'projectId',
        operator: '==',
        value: globalState.currentProject,
      }
    ];
    const sortBy = { field: 'lastUpdated', direction: 'desc' };
    const limitValue = startIndex + itemsPerPage;
    try {
      const res = await getCollectionFirebase(
        'discounts',
        conditions,
        sortBy,
        limitValue,
      );
      setDataProduct(res);

      const collectionRef = collection(db, 'product');

      // Membuat kondisi filter tambahan untuk pemilik (owner) jika filterOwner aktif
      const countQuery = query(collectionRef,
        where('companyId', '==', globalState.currentCompany),
        where('projectId', '==', globalState.currentProject),
      );


      const snapshot = await getCountFromServer(countQuery);
      const assessmentLength = snapshot.data().count;

      setTotalPages(Math.ceil(assessmentLength / itemsPerPage));

    } catch (error) {
      toast({
        title: 'Deoapp.com',
        description: error.message,
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
    }
  };


  useEffect(() => {
    getData();


  }, [globalState?.currentProject, currentPage]);
  // console.log(dataProduct, 'yupi')
  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleBulk = () => {
    navigate('/discount/bulk')
  }

  const handleGenerateLink = (arg) => {
    try {
      // navigator.clipboard.writeText(`${window.location.host}/checkout?slug=${arg.data.slug}`);
      navigator.clipboard.writeText(`https://deoapp-page-view-qwik.vercel.app/buy/${arg.data?.slug}`);
      toast({
        description: 'Checkout page link copied!',
        status: 'success',
        duration: 2000,
        position: 'top'
      })
    } catch (error) {
      console.log(error.message, 'error copy clipboard')
    }
  };



  const tableHeader = ['name', 'type', 'status'];


  let tableData = '';
  console.log(dataProduct,'prod')
  tableData = dataProduct?.map((data) => {
    const name = data?.name || '';
    const status = data?.status === true ? 'Akif' : 'Tidak Aktif';
    const type = data?.type || '';

    return {
      data,
      // image,
      name: (
        <Stack spacing={1}>
          <Text fontWeight={500} textTransform={'capitalize'}>
            {name}
          </Text>
          <Text fontSize={9}>{data?.id}</Text>
        </Stack>
      ),
      // sold,
      // price,
      // stocks,
      type,
      status,
      // published,
      // on_discount
    };
  });
  // console.log(tableData)
  const handleDetail = (x) => {
    // console.log(x.data)
    navigate(`/discount/${x?.data?.id}`)
  }

  const deleteData = async (x) => {
    const confirmDelete = window.confirm('If you delete this data you can\'t Undo');
    if (confirmDelete)

      try {
        await deleteDocumentFirebase('discounts', x.data.id)
        getData()
        toast({
          title: 'Success',
          description: `Delete ${x.data.name} success`,
          status: 'success',
        })
      } catch (error) {
        toast({
          title: 'error',
          description: `${error.message}`,
          status: 'error',
        })
      }
  }

  const arrayToString = (arr) => {
    if (!Array.isArray(arr)) {
      return '';
    }
    return arr.join(', ');
  };
  const excelData = dataProduct.map((x) => {
    const string = {
      id: x.id || '',
      name: x?.name || '',
      type: x?.type || '',
      amount: x?.amount || '',
      companyId: x?.companyId || '',
      projectId: x?.projectId || '',
      createdAt: x?.createdAt || '',
      createdBy: x?.createdBy || '',
      description: x?.description || '',
      startDate: x?.startDate || '',
      endDate: x?.endDate || '',
      flatPrice: x?.flatPrice || '',
      status: x?.status || '',
      variantId: arrayToString(x?.variantId) || '',
    }
    return string
  })

  return (
    <Box>
      <Stack py={2}>
        <HStack gap={5}>
          <BackButtons />
          <Text fontSize={'xl'} fontWeight={500}>
            Discount
          </Text>
          <Spacer />
          <DynamicButton action={'create'} onClick={onOpen} title={'Add Discount'} />
          <DynamicButton action={'create'} onClick={handleBulk} title={'Bulk Add Product'} />
          <ComponentExportExcel excelData={excelData} fileName={'Discount Data'} />
        </HStack>

        <Divider />
      </Stack>

      <Box>
        <DynamicTable
          header={tableHeader}
          data={tableData}
          onDelete={deleteData}
          // onRead={openModalDeleteRole}
          onEdit={handleDetail}
          // onCustom={handleGenerateLink}
          action_color='green'
          action_icon={PiShareBold}
          editTooltip={'Edit Discount Details'}
          // customTooltip={'Generate checkout link'}
          deleteTooltip={'Delete this Discount'}
        />

        <Stack alignItems={'center'} justifyContent="center" py={5}>
          <Box>
            {currentPage < totalPages && (
              <Button colorScheme={'blue'} fontSize="sm" onClick={handleLoadMore}>
                Load More
              </Button>
            )}
          </Box>
        </Stack>
      </Box>





      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add new Discount</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Lorem count={2} /> */}
            <Input type="text" placeholder='Discount name' onChange={(e) => setName(e.target.value)} />
          </ModalBody>

          <ModalFooter>
            <DynamicButton
              action={'create'}
              onClick={createNewProduct}
              title="Save"
              variant={'solid'}
            />
          </ModalFooter>
        </ModalContent>
      </Modal>


    </Box>
  );
};

export default ProductPageV2;
